import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Link, Box } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

export const HeaderList = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 0px;

  ${mediaQuery.minWidth.md} {
    flex-direction: row;
  }
`;

export const HeaderListItem = styled.li`
  border-bottom: 1px solid ${themeGet('colors.white')};

  .nav-dropdown-menu {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
    z-index: ${themeGet('zIndices.navigationDropdown')};
    position: absolute;
  }

  ${mediaQuery.minWidth.md} {
    border-bottom: none;

    &:hover,
    &:focus,
    &.open-dropdown-menu {
      background-color: ${themeGet('colors.white')};

      > a,
      button {
        color: ${themeGet('colors.brand.primary')};
      }

      .nav-dropdown-menu {
        visibility: visible;
        opacity: 1;
      }
    }
  }
`;

export const StyledLink = styled(Link)`
  width: 100%;
  color: ${themeGet('colors.white')};
  padding: ${themeGet('space.5')} ${themeGet('space.5')};

  &:hover {
    color: ${themeGet('colors.white')};
  }

  ${mediaQuery.minWidth.md} {
    font-size: ${themeGet('fontSizes.base')};
  }
`;

export const DropdownLink = styled(Box)`
  &:hover {
    > a {
      color: ${themeGet('colors.brand.primary')};
    }
  }
`;
